import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { PointsBasedTagsDetailView } from "@features/dashboard/components/Progress/PointsBasedTagsDetailView";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useActiveStudyPackCollectionId } from "@hooks/useActiveStudyPackCollectionId";
import { useAppStore } from "@hooks/useAppStore";
import { getMixedItemDistQueryKey } from "@hooks/useMixedItemDist";
import { titleCase } from "@memorang/helpers/common";
import type { MixedItemDist } from "@memorang/types";
import { useQueryClient } from "@tanstack/react-query";
import TopicsDetailView from "components/Topics/TopicsDetailView";
import { useLocalSearchParams } from "expo-router";

const DetailedListMasteryContainer = () => {
	const { type } = useLocalSearchParams<{
		type: string;
	}>();

	const { userPublicMetadataId } = useAuthContext();

	const {
		currentExamContext: { examId },
	} = useExamContext();
	const { collectionId } = useActiveStudyPackCollectionId();

	const queryClient = useQueryClient();
	const showPointsBasedScore = useAppStore(
		(state) => state.reportView?.formative?.showPointsBasedScore,
	);
	const commonDistribution = queryClient.getQueryData<MixedItemDist>(
		getMixedItemDistQueryKey({
			userPublicMetadataId,
			action: "COMMON_DISTRIBUTION",
			examId,
			collectionId,
		}),
	);

	if (!commonDistribution) {
		return null;
	}

	const { tags } = commonDistribution;

	if (showPointsBasedScore) {
		return (
			<PointsBasedTagsDetailView title={`${titleCase(type!)}s`} tags={tags} />
		);
	}

	return <TopicsDetailView tags={tags} type={type} />;
};

export default DetailedListMasteryContainer;
